import { camelizeKeys } from 'humps';
import { call, takeLatest, put, all, select } from 'redux-saga/effects';

import api from '../../lib/api';
import endpoints from '../../lib/endpoints';

import {
  FETCH_REVIEWS,
  ADD_REVIEW,
  ADD_REPLY,
  DELETE_REVIEW,
  DELETE_REPLY,
} from '../actions/types';

import {
  storeReviews,
  updateReply,
  updateReview,
} from '../actions/reviewsActions';
import {
  getLodgeIdFromUrl,
  getUserIdFromUrl,
  getTrekIdFromUrl,
} from '../../lib/utils';
import { getCustomToast } from '../../components/ErrorMessage';

export default function* watchReviews() {
  yield all([
    takeLatest(FETCH_REVIEWS, fetchReviews),
    takeLatest(ADD_REVIEW, addReview),
    takeLatest(ADD_REPLY, addReply),
    takeLatest(DELETE_REVIEW, deleteReview),
    takeLatest(DELETE_REPLY, deleteReply),
  ]);
}

function* fetchReviews({ origin }) {
  try {
    const url = endpoints[origin].reviews(id[origin]());

    const { data } = yield call(api.get, url);
    yield put(storeReviews(camelizeKeys(data.comments)));
  } catch (err) {
    console.log(err);
  }
}

function* addReview({ review, origin, userInfo }) {
  try {
    const url = endpoints[origin].reviews(id[origin]());
    const { user } = yield select();

    let data = null;

    if (user.userId) {
      const response = yield call(api.post, url, { comment: review });
      data = response.data;
    } else {
      // for guest login
      const { token, ...rest } = userInfo;
      const response = yield call(
        api.postAsAGuest,
        url,
        { comment: review, ...rest },
        token
      );
      data = response.data;
    }

    getCustomToast('We appreciate your reviews.', 'success');
    yield put(updateReview(camelizeKeys(data.comments)));
  } catch (err) {
    console.log(err);
  }
}

function* addReply({ reviewId, review, origin }) {
  try {
    const url = endpoints[origin].reply(id[origin](), reviewId);

    const { data } = yield call(api.post, url, { comment: review });
    yield put(updateReply(camelizeKeys(data.comments)));
  } catch (err) {
    console.log(err);
  }
}

function* deleteReview({ reviewId, origin }) {
  try {
    const url = endpoints[origin].reviews(id[origin]());

    const { data } = yield call(api.delete, url, reviewId);
    yield put(updateReview(camelizeKeys(data.comments)));
  } catch (err) {
    console.log(err);
  }
}

function* deleteReply({ replyId, origin }) {
  try {
    const url = endpoints[origin].reply(id[origin](), replyId);

    const { data } = yield call(api.delete, url);
    yield put(updateReply(camelizeKeys(data.comments)));
  } catch (err) {
    console.log(err);
  }
}

const id = {
  treks: getTrekIdFromUrl,
  lodge: getLodgeIdFromUrl,
  profile: getUserIdFromUrl,
  flights: () => 'f8016c413194',
};



// WEBPACK FOOTER //
// ./src/redux/sagas/reviews.js